import React, { useEffect } from 'react';

const BusinessAccountInputLabel = (props: any) => {
    const { labelProps } = props;
    // List of fields that need to be mandatory
    const mandatoryFieldsArray: string[] = ['company_addressstreetnumber', 'company_addressphone'];

    useEffect(() => {
        if (mandatoryFieldsArray.includes(labelProps.props.id)) {
            const labelElement = document.querySelector(`label[for=${labelProps.props.id}]`);
            if (labelElement) {
                labelElement.innerHTML = `${labelProps.props.text} *`;
            }
        }
    });

    return <>{labelProps}</>;
};

export default BusinessAccountInputLabel;
